import React from 'react';

import { useFormikContext } from 'formik';

import Checkbox from 'components/shared/Checkbox/Checkbox';

const options = [
  {
    label: 'CSV',
    value: 'csv'
  },
  {
    label: 'Excel',
    value: 'excel'
  },
  {
    label: 'PDF (or Print)',
    value: 'pdf'
  }
];

const ExportTypeCheckbox = () => {
  const { values, setFieldValue, errors, submitCount } = useFormikContext();
  const hasExportTypeError = Boolean(errors.export_type) && submitCount > 0;

  return (
    <div>
      <div className="flex items-center gap-2">
        <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
          File type
          <span className="text-danger-400">*</span>
        </label>
        {hasExportTypeError && (
          <span className="text-sm text-danger-500">At least one export type is required.</span>
        )}
      </div>

      <div className="mt-2 flex flex-wrap gap-4">
        {options?.map((option, idx) => {
          const value = typeof option === 'object' ? option?.value : option;
          return (
            <Checkbox
              key={idx}
              data-qa={`checkbox-${option}`}
              isChecked={values?.export_type?.includes(value)}
              handleClick={() => {
                const newValues = values?.export_type?.includes(value)
                  ? values?.export_type?.filter((val) => val !== value)
                  : [...(values?.export_type || []), value];

                setFieldValue('export_type', newValues);
              }}
              label={option?.label}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExportTypeCheckbox;
